<template>
<div ref="platleveladd">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">新增版本管理</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="levellist.length > 1 ? levellist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="clearAll">清空已填模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="addpetmodel">新增模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回版本管理</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in levellist" :key="index">
            <div class="TTL-form-submit-box-title">版本-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" v-if="index > 0" @click.stop="delpet(index)">删除</el-button>
            </div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">版本名称<i>*</i></label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.levelname" placeholder="请输入账号名称" @change="SaveDataToBrowser" clearable />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">描述</label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input type="textarea" v-model="item.note" class="width350" :autosize="{ minRows: 6, maxRows: 8}" />
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/index';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            addlimit: 10,                               //单次新增限制
            uploadimageIndex:'',                        //获取当前上传图片的序号
            levellist:[{levelname:'',note:''}],         //版本列表
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 页数初始化 **/
        OnloadMethod() {
            
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                this.ParseDataFromBrowser();
            } 
        },


        /** 提交数据 **/
        submitData() {
            //调整提交数据
            var data=[];
            for(var i=0;i<this.levellist.length;i++) data.push(this.levellist[i]);
            data=JSON.stringify(data);

            var loadingobj=this.$refs.platleveladd;
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_SHOP.ADD_PLATFORM_LEVEL({managerdata:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            });
        },



        /** 清空当前数据 **/
        clearAll() {
            this.$confirm.confirm(
                '您是否确定要删除当前所有账号信息 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.resetParam();
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            }).catch(()=> {

            });
        },

        
        /** 新增品种模板信息 **/
        addpetmodel() {
            if(this.levellist.length >= this.addlimit) {
                this.$notice({title:'消息提示',message:'单次添加版本数量请最多不要超过'+this.addlimit+'个',type:'warning'});
                return false;
            }

            var level={levelname:'',note:''};
            this.levellist.push(level);
            this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
        },


        /** 删除单个品种信息 **/
        delpet(index) {
            this.levellist.splice(index,1);
            this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
        },


        /** 上传图片信息 **/
        uploadimages(index) {
            this.uploadimageIndex=index;                          //标记当前上传图片序号
            var obj=document.querySelector('#TTLFiles');          //获取文件对象
            obj.click();                                          //点击触发上传图片
            obj.addEventListener('change',this.uploadimagedata);  //添加监听事件
        },


        /** 上传图片信息操作 **/
        uploadimagedata(e) {
            var _this=this;
            this.file=e.target.files[0];       //获取上传的图片
            e.target.value=null;                //清空数据
            document.querySelector('#TTLFiles').removeEventListener('change',this.uploadimagedata);  //解除监听事件

            //上传图片到接口操作
            INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:'normal',File:this.file}).then((res) => {
                if(res.status > 0) return false;
                _this.levellist[_this.uploadimageIndex].logo=_this.$ImageAddress+res.data.url;
                _this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            });
        },



        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载


        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.levellist);
            localStorage.setItem('addplatleveldata',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('addplatleveldata');
            data ? data : data=[];
            !data || data=='' || data==[] ? this.resetParam() : this.levellist=JSON.parse(data);
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'平台账号版本管理',labelentry:'PlatFormLevel',components:'PlatFormLevel',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

        /** 重置加载数据 **/
        resetParam() {
            this.levellist=[];
            var managerinfos={levelname:'',note:''};
            this.levellist.push(managerinfos);
            this.SaveDataToBrowser();
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
</style>